export const URL_ADD_TO_CART = '/api/v2/cart/add_to_cart';
export const URL_REMOVE_FROM_CART = '/buyer/cart/del_item/';

// V4
export const URL_ADD_TO_CART_V4 = '/api/v4/cart/add_to_cart';
export const URL_ADD_TO_CART_BATCH_V4 = '/api/v4/cart/add_to_cart_batch';
